import React from "react"
import { getMeasures } from "../utils/utils"
import ContentTable from "./contentTable"
import info from '../images/info.png'

import "./content.css"

const Content = ({ text, utils }) => {
  return (
    <div className="content-page">
      <h2>{text.h2}</h2>
      <p>{text.p1}:</p>
      <table className="content-table">
        <thead>
          <tr>
            <th>{text.table1.decimal}</th>
            <th>{text.table1.fraction}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>0,25</td>
            <td>1/4</td>
          </tr>
          <tr>
            <td>0,33</td>
            <td>1/3</td>
          </tr>
          <tr>
            <td>0,5</td>
            <td>1/2</td>
          </tr>
          <tr>
            <td>0,66</td>
            <td>2/3</td>
          </tr>
          <tr>
            <td>0,75</td>
            <td>3/4</td>
          </tr>
        </tbody>
      </table>
      <p id="pre-tables">{text.p2}.</p>
      {utils.ingredients.map((ingredient, index) => {
        const labelRatios = getMeasures(
          ingredient,
          utils.solidMeasures,
          utils.liquidMeasures
        )
        return (
          <ContentTable
            key={index}
            ingredient={ingredient.label}
            ths={text.contentTable}
            tableRows={labelRatios}
            type={ingredient.type}
          />
        )
      })}
      <div className="info-alert">
        <img src={info} alt="info icon" />
        <p>{text.p3}.</p>
      </div>
    </div>
  )
}
export default Content
